import Vue, { ref } from 'vue'
import { defineStore } from 'pinia'
import { ChainingAdditionalInformationAdapter } from '../adapter/ChainingAdditionalInformationAdapter'
import { ChainingAdditionalInformationDto } from '../types/ChainingAdditionalInformationDto'
import { ChainingAssociatedPatientServiceCreateDto } from '../types/ChainingAssociatedPatientService'

export const useChainingStore = defineStore('chaining', () => {
    const inheritSpeciality = ref<boolean>(false)
    const sejourId = ref<number>()
    const groupId = ref<number>()
    const objectClass = ref<string>()
    const linkedServiceObjectClass = ref<string>()
    const linkedServiceObjectId = ref<number>()
    const objectId = ref<number>()
    const drugBase = ref<string>()
    const drugBaseLanguage = ref<string>()

    const getAdditionalInformation = () => {
        return Vue.$http
            .get(
                `api/v1/chaining/additionalInformation/${objectClass.value}/${objectId.value}`,
                new ChainingAdditionalInformationAdapter(),
            )
            .toPromise()
    }

    const createAdditionalInformation = (data: Partial<ChainingAdditionalInformationDto>) => {
        return Vue.$http
            .post(
                `api/v1/chaining/additionalInformation/${objectClass.value}/${objectId.value}`,
                new ChainingAdditionalInformationAdapter(),
                data,
            )
            .toPromise()
    }

    const updateAdditionalInformation = (data: Partial<ChainingAdditionalInformationDto>) => {
        return Vue.$http
            .put(
                `api/v1/chaining/additionalInformation/${objectClass.value}/${objectId.value}`,
                new ChainingAdditionalInformationAdapter(),
                data,
            )
            .toPromise()
    }

    const submitDefaultChainings = (data: ChainingAssociatedPatientServiceCreateDto[]) => {
        return Vue.$http
            .post(
                `api/v1/chaining/default/${objectClass.value}/${objectId.value}`,
                new ChainingAdditionalInformationAdapter(),
                data,
            )
            .toPromise()
    }

    const setObject = (objectClassGiven: string, objectIdGiven: number) => {
        objectClass.value = objectClassGiven
        objectId.value = objectIdGiven
    }

    const setLinkedServiceObject = (objectClassGiven: string, objectIdGiven: number) => {
        linkedServiceObjectClass.value = objectClassGiven
        linkedServiceObjectId.value = objectIdGiven
    }

    return {
        inheritSpeciality,
        sejourId,
        groupId,
        drugBase,
        drugBaseLanguage,
        linkedServiceObjectId,
        linkedServiceObjectClass,
        setObject,
        setLinkedServiceObject,
        getAdditionalInformation,
        createAdditionalInformation,
        updateAdditionalInformation,
        submitDefaultChainings,
    }
})
